import { formatDateForUI, formatDateTimeForUI } from '~/shared/lib/date'
import { AsyncGridColumns, ColumnValue } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.start at',
    field: 'createdAt',
    flex: 1,
    renderCell: ({ value }) => (value ? formatDateTimeForUI(value) : ''),
  },
  {
    headerName: 'column.date of entry',
    field: 'depositingDate',
    flex: 1,
    renderCell: ({ value }) => (value ? formatDateForUI(value) : ''),
  },
  {
    headerName: 'column.user',
    field: 'user',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.total',
    field: 'amount',
    flex: 1,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
  {
    headerName: 'column.comment',
    field: 'comment',
    flex: 1,
  },
]
